// 方案中心
import request from "@/utils/request.js";
// let path = "/api";
const Plan = {
  /**
   * 查询
   * @param name @type String 文章名
   * @param caseType @type String 类型
   * @param startTime @type String 用户名
   * @param endTime @type String 密码
   * @param type @type String 类型 1=软件，2=硬件，3=防治方案
   * @param page @type String 页码
   * @param pageSize @type String 条数
   */
  queryAcList: async (data) => {
    return await request("post", "/plan-data/list-data", data);
  },

  /**
   * 添加/修改用户
   * @param id @type String id  再新增的时候直接不传这个参数 在修改的时候再传
   * @param name @type String 用户名
   * @param introduction @type String
   * @param startStatus @type Number
   * @param imgUrl @type String 图片地址
   * @param innerText @type String 内容
   * @param type @type String 类型 1 软件方案 2 硬件方案 3防治方案
   * @param delStatus @type String   未删除为0   删除为1
   * @param createTime  @type String   创建时间
   * @param betterStatus  @type String   首页优秀方案 1=启用，2=禁用
   */
  addOrUpDate: async (data) => {
    return await request("post", "/plan-data/add", data);
  },
  /**
   * 登录获取token
   * @param id @type String 文章id
   */
  delAcList: async (data) => {
    return await request("get", "/plan-data/logic-del-plan", data);
  },

  /**
   * 解决方案详情-查询
   * @param planDataCenterId @type String 解决方案ID
   */
  getDetail: async (params) => {
    return await request("get", "/plan-data/detail", params);
  },
};
export default Plan;



// WEBPACK FOOTER //
// ./src/api/plan.js